var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "check_more_department" },
    [
      _c("yxtbiz-dept-tree", {
        ref: "deptTree",
        staticClass: "department_tree",
        attrs: {
          openSelectSiblingNode: _vm.openSelectSiblingNode,
          targetOrgId: _vm.targetOrgId,
          disabled: _vm.disabled,
          visibleOrgSelector: _vm.visibleOrgSelector,
          visibleOrgIds: _vm.visibleOrgIds,
          enableGroupCorp: _vm.enableGroupCorp,
          filterable: "",
          size: "small",
          placeholder: _vm.$t("biz_udp_enter_deptmentname"),
          "check-strictly": !!_vm.checkStrictly,
          "show-checkbox": "",
          multiple: _vm.multiple,
          "children-included": _vm.childrenIncluded,
          functions: !!_vm.childrenIncluded && _vm.functions,
          functionCode: _vm.functionCode,
          dataPermissionCode: _vm.dataPermissionCode,
          count: _vm.userCount,
          checkedLinkage: "1",
        },
        on: {
          "org-change": _vm.handleOrgChange,
          close: _vm.closeTag,
          check: _vm.handleCheck,
          clearNode: _vm.handleCheck,
          nodeClick: _vm.handleNodeClick,
          selectSiblingChange: _vm.selectSiblingChange,
          inited: _vm.init,
          loaded: _vm.loaded,
          includeChanged: _vm.handleTypeChange,
          change: _vm.change,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }